import { Controparte } from "../controparte";
import { MetadataExt } from "../metadati/metadata";
import { FascicoloBase } from './fascicolo-base';
import { RiassuntoFascicolo } from './riassunto-fascicolo';

export class FascicoloLight extends FascicoloBase {
    riassunto?: RiassuntoFascicolo;
    visible?: boolean;
    selected?: boolean;
    selectedAllControparti?: boolean;
    controparti?: Controparte[];
    metadata: MetadataExt[];
}
